import React, { Component } from 'react';
import _ from 'lodash';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'
import { connect } from 'react-redux';
class NavBottomFixed extends Component {

  constructor(props) {
    super(props);

    try {

      this.state = {
        activeNode: -1, //no active node
        activeSubNode: -1 //no active subnode 
      }
      this._indexData = [];
  
      this._module = _.find(this.props.content.dm_active, { display_module_type: "Module Grouping" });
      if (!this._module) {
        console.log("Expecting a Grouping Module for navigation to be added to display");
      }
      this._navigation = this._module.contents.module_tree.children;
      this._useFolders = _.get(this._module, 'contents.useFolders', false);
      this._fontClass = _.get(this._module, 'contents.custom_fields.font_family.val.value', null);
      this._navItemFont = _.get(this._module, 'contents.custom_fields.override_font_family.val', "Ostrich");
      this._navGroupFont = _.get(this._module, 'contents.custom_fields.override_font_family.val', "Ostrich");
  
      for (var a = 0; a < this._navigation.length; a++) {
        for (var b = 0; b < this._navigation[a].modules.length; b++) { //exactly 1 nestings
          this._indexData.push(this.setNavigationData(this._navigation[a], this._navigation[a].modules[b], this._useFolders));
        }
      }
      this._folderTypeAlias = [{
        name: "Stories Folders",
        types: ['families', 'babies']
      }];
      this.nav_groups = [];
      for (var c = 0; c < this._navigation.length; c++) {
        let mod = { name: this._navigation[c].name, modules: [] }
        for (var d = 0; d < this._navigation[c].modules.length; d++) {
          if (this._useFolders) {
            let index, foundType, type;
            for (let i = 0; i < this._folderTypeAlias.length; i++) {
              index = _.findIndex(this.props.content.story_categories, { id: this._navigation[c].modules[d].id });
              foundType = _.get(this.props.content.story_categories[index], 'contents.custom_fields.folder_type.val.value', "Stories");
              if (this._folderTypeAlias[i].types.indexOf(foundType) > -1) {
                type = this._folderTypeAlias[i].name;
                break;
              }
            }
            mod.modules.push(
              {
                name: this._navigation[c].modules[d].name,
                display_module_type: type,
                dm_active_ref: index
              }
            )
          } else {
            mod.modules.push(
              {
                name: this._navigation[c].modules[d].name,
                display_module_type: _.find(this.props.content.display_module_types, { id: Number(this._navigation[c].modules[d].display_module_type) }).name,
                dm_active_ref: _.findIndex(this.props.content.dm_active, { id: this._navigation[c].modules[d].id }),
              }
            )
          }
        }
        this.nav_groups.push(mod);
      }
    } catch(e) {
      console.log(e);
    }

  }

  setNavigationData = (parent, data, useFolders) => {
    var obj = {};
    var type = "";
    if (useFolders) {
      obj = { parent: parent, name: data.name, activeIndex: _.findIndex(this.props.content.story_categories, { id: data.id }), hasContent: true };
      type = "story";
    } else {
      obj = { parent: parent, name: data.name, activeIndex: _.findIndex(this.props.content.dm_active, { id: data.id }), hasContent: false };
      type = _.find(this.props.content.display_module_types, { id: Number(data.display_module_type) }).name;
    }

    obj.display_module_type = type;
    switch (type) {
      case "Timeline":
        if (_.has(this.props.content, 'dm_active[' + obj.activeIndex + '].contents.events') && this.props.content.dm_active[obj.activeIndex].contents.events.length > 0) {
          obj.hasContent = true
        }
        break;
      case "Donor List":
        if (_.has(this.props.content, 'dm_active[' + obj.activeIndex + '].contents.include_categories')) {
          var includes = this.props.content.dm_active[obj.activeIndex].contents.include_categories;
          for (var i = 0; i < includes.length; i++) {
            var category = _.find(this.props.donors.donorCategories, { id: includes[i] });
            if (category && category.donors && category.donors.length > 0) {
              obj.hasContent = true;
            }
          }
        }
        break;
      default:
        break;
    }
    return obj;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.idle !== this.props.idle) {
      this.setState({
        activeNode: -1, //no active node
        activeSubNode: -1 //no active subnode 
      })
    }
  }

  handleNavGroupChange = (row, index) => {
    this.setState({
      activeNode: index,
    })
  }

  handleNavIndex = (name) => {
    var item = _.find(this._indexData, { parent: { name: name } });
    if (item) {
      if (item.hasContent === true) {
        return item.activeIndex;
      }
      else {
        return -1;
      }
    }
    return -1;
  }

  handleNav = (name, row, index) => {
    let activeIndex = -1;
    activeIndex = row.dm_active_ref
    let options = { type: _.get(this.props.content, 'dm_active[' + row.dm_active_ref + '].contents.custom_fields.type.val.value', "avatar"), useFolders: this._useFolders }
    if (activeIndex > -1) {
      this.props.navroute(activeIndex, row.display_module_type, "bottomFixed", options);
    }
    if (activeIndex !== -1) {
      this.setState({
        activeSubNode: row.name
      })
    }

  }

  tryNav = (activeIndex, type, options) => {
    if (activeIndex >= 0) {
      this.props.navroute(activeIndex, type, "bottomFixed", options);
    }
  }

  prepareInnerNav = (name, modules, config, index) => {
    let margin = this.props.screen.r16_9.p10 * .1
    return (
      modules.map(function (row, i) {
        return (
          <span onClick={() => this.handleNav(name, row, i)} key={i} style={{ display: 'inline-block', fontFamily: this._navItemFont, letterSpacing: "1px", height: config.height, fontSize: config.fontSizeInner, paddingLeft: config.padding, paddingRight: config.padding }}>
            <span className={this.state.activeNode === index ? "slideOut" : "slideIn"} style={{ display: 'inline-block', paddingTop: config.unit * .42 }}>

              <CSSTransitionGroup
                component='div'
                transitionName='example'
                transitionEnterTimeout={0}
                transitionLeaveTimeout={0}>
                {row.name === this.state.activeSubNode ?
                  <span key={this.state.activeSubNode} style={{ marginLeft: -margin, marginRight: -margin, paddingTop: margin + this.props.screen.r16_9.p10 * .02, paddingBottom: margin, paddingLeft: margin, paddingRight: margin, position: 'absolute', top: this.props.screen.r16_9.p10 * .3, color: 'white', backgroundColor: '#496778', borderRadius: 7 }}>
                    {row.name}
                  </span>
                  :
                  <span key={this.state.activeSubNode} style={{ marginLeft: -margin, marginRight: -margin, paddingTop: margin + this.props.screen.r16_9.p10 * .02, paddingBottom: margin, paddingLeft: margin, paddingRight: margin, position: 'absolute', top: this.props.screen.r16_9.p10 * .3, color: '#496778' }}>
                    {row.name}
                  </span>}
              </CSSTransitionGroup>

              <span style={{ opacity: 0 }}>
                {row.name}
              </span>
            </span>
          </span>
        )
      }, this)
    )
  }

  prepareNavGroups = (config) => {
    let pointerEvents = "none";
    if (!this.props.idle) {
      pointerEvents = "auto";
    }
    return (
      this.nav_groups.map(function (row, i) {
        return (
          <span key={i} style={{ pointerEvents: pointerEvents }}>
            <span key={i} style={{ verticalAlign: 'bottom', display: 'table-cell', backgroundColor: '#a4bcc2', letterSpacing: '1px', color: '#496778', fontFamily: this._navGroupFont, fontSize: config.fontSize, paddingLeft: config.padding, paddingRight: config.padding, height: config.height }} onClick={() => this.handleNavGroupChange(row, i)}>
              <span style={{ display: 'inline-block', paddingBottom: config.unit * .25 }}>{row.name}</span>
            </span>

            <span className={this.state.activeNode === i ? "slideOut" : "slideIn"} style={{ position: 'relative', verticalAlign: 'bottom', display: 'table-cell', backgroundColor: '#a4bcc2', color: "#496778", height: config.height }}>
              <span style={{ pointerEvents: 'none', position: 'absolute', left: 0, top: this.props.screen.r16_9.p10 * .2, backgroundColor: '#fcfcfc', width: '100%', height: config.height - this.props.screen.r16_9.p10 * .4, borderRadius: 15 }} />
              <span style={{ zIndex: 51 }}>
                {this.prepareInnerNav(row.name, row.modules, config, i)}
              </span>
            </span>
          </span>

        )
      }, this)
    )


  }



  render() {
    let config = {
      height: this.props.screen.r16_9.p10,
      fontSize: this.props.screen.r16_9.p10 * .4,
      fontSizeInner: this.props.screen.r16_9.p10 * .2,
      padding: this.props.screen.r16_9.p10 * .2,
      unit: this.props.screen.r16_9.p10
    }

    let navGroups = this.prepareNavGroups(config);

    return (
      <div style={{ zIndex: 50, margin: 'auto', position: 'absolute', bottom: 0, backgroundColor: '#a4bcc2', left: this.props.screen.r16_9.left, width: this.props.screen.r16_9.width, height: config.height }}>
        {navGroups}
      </div>
    )
  }
}

const mapStateToProps = (state) => {

  return {
    content: state.content,
    screen: state.screen
  };
};

export default connect(mapStateToProps, null)(NavBottomFixed)



// WEBPACK FOOTER //
// ./src/Components/Navigation/NavBottomFixed.js